import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { role: "banner" }
const _hoisted_2 = {
  key: 0,
  class: "mobile-locale-selector"
}

import { IonHeader, IonMenuButton } from "@ionic/vue";
import LocaleSelector from "@/components/Common/LocaleSelector/LocaleSelector.vue";
import { useLocaleStore } from "@/store";

export default /*@__PURE__*/_defineComponent({
  __name: 'MobileHeader',
  setup(__props) {

const localeStore = useLocaleStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_unref(IonHeader), { role: "" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonMenuButton), {
          class: "mobile-menu-hamburger",
          "data-test": "mobile-menu-hamburger"
        }),
        (_unref(localeStore).getShowLocaleSwitcher)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(LocaleSelector, {
                "data-test": "mobile-locale-selector",
                selectedLocaleCode: _unref(localeStore).currentLocale,
                allowedLocaleCodes: _unref(localeStore).getAllowedLocaleCodes
              }, null, 8, ["selectedLocaleCode", "allowedLocaleCodes"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})